import React from 'react';
import { PropTypes } from 'prop-types';
import Select, { components } from 'react-select';
import { IndicatorsContainer } from '../../SelectFilter';
import { Checkbox, Layout } from '../../../../core';
import { ProgressSpinner } from '../../../progress-spinner';
import { AsyncSelectBoxListStyles } from '../../../Form/Controls/SelectControl.styles';
import { i18n } from '../../../../i18n/translate';

export const SelectComponent = props => {
  const {
    singleSelect,
    disabled,
    name,
    searchCaption,
    selectProps,
    label,
    selectedOptions,
    valueList,
    isLoading,
    onChange,
    onInputChange,
  } = props;

  console.log('isLoading', isLoading);
  const commonProps = {
    name,
    isDisabled: disabled,
    isLoading,
    value: selectedOptions,
    onChange,
    onInputChange,
    isMulti: !singleSelect,
    autoFocus: true,
    blurInputOnSelect: false,
    closeMenuOnSelect: false,
    hideSelectedOptions: false,
    backspaceRemovesValue: false,
    tabSelectsValue: false,
    isSearchable: true,
    placeholder: `Select ${label || searchCaption}...`,
    loadingMessage: () => i18n.t('Loading...'),
    menuPortalTarget: undefined,
    styles: AsyncSelectBoxListStyles,
    noOptionsMessage: ({ inputValue }) => (inputValue ? i18n.t('No options found') : i18n.t('Start typing to search')),
    ...selectProps,
    controlShouldRenderValue: false,
  };

  const Option = props => {
    return (
      <div>
        <components.Option {...props}>
          <Checkbox tabIndex={-1} isChecked={props.isSelected} label={props.label} />
        </components.Option>
      </div>
    );
  };

  return (
    <Select
      {...commonProps}
      components={{
        Option,
        IndicatorsContainer,
      }}
      menuIsOpen={true}
      options={valueList}
    />
  );
};

SelectComponent.propTypes = {
  singleSelect: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  searchCaption: PropTypes.string,
  selectProps: PropTypes.object,
  label: PropTypes.string,
  selectedOptions: PropTypes.any,
  valueList: PropTypes.array,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
};
